import styled, { css } from "styled-components/macro";
import { COLORES } from "../../constants";

export const Tr = styled.form`
  display: table-row;
  height: 1.75rem;

  background-color: ${(props) =>
    props.highlighted ? COLORES.HIGHLIGHTED : COLORES.BACKGROUND};

  :hover {
    background-color: ${COLORES.HIGHLIGHTED};
  }

  color: ${(props) => props.deleted && COLORES.DELETED};
`;

export const Td = styled.div`
  display: table-cell;
  vertical-align: middle;
  border: thin solid ${COLORES.LIGHT_BORDER};
  text-align: ${(props) => props.button && "center"};

  ${(props) =>
    props.type !== "enum" &&
    props.type !== "relate" &&
    css`      
      text-overflow: ellipsis;
      white-space: nowrap;
    `}

  button {
    line-height: 1.5rem;
  }

  .edit {
    font-size: 1.25rem;
    font-weight: normal;
    margin: 0.1rem 0;
    padding: 0;
    width: calc(100% - 0.2rem);
  }
`;

export const Buttons = styled.div`
  display: flex;

  button {
    flex-grow: 1;
    border: none;
    border-radius: 0.2rem;
    margin-left: 0.2rem;
    color: ${COLORES.BUTTON_TEXT_DEFAULT};
    width: 2rem;

    :disabled {
      background-color: ${COLORES.BACKGROUND_DISABLED};
      cursor: default;
    }
  }

  button:last-of-type {
    margin-right: 0.2rem;
  }

  .action {
    font-weight: bold;
    font-size: 0.75rem;
  }

  .delete {
    background-color: ${COLORES.BACKWARD};
  }
`;
